import { render, staticRenderFns } from "./BotonesCompartir.vue?vue&type=template&id=4b925366&scoped=true"
import script from "./BotonesCompartir.vue?vue&type=script&lang=js"
export * from "./BotonesCompartir.vue?vue&type=script&lang=js"
import style0 from "./BotonesCompartir.vue?vue&type=style&index=0&id=4b925366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b925366",
  null
  
)

export default component.exports